import React, { useEffect, useState } from 'react';
import FixedElementsPortal from './FixedElementsPortal';
import PropTypes from 'prop-types';

const ResponsiveFixedPortalWrapper = ({ children })  => {
  const [isSmallDevice, setIsSmallDevice] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleWindowSizeChange = () => {
      const newWidth = window.innerWidth;
      if (isSmallDevice && newWidth > 768) {
        setIsSmallDevice(false);
      } else if (!isSmallDevice && newWidth <= 768) {
        setIsSmallDevice(true);
      }
    };

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [isSmallDevice]);

  return isSmallDevice ? (
    <FixedElementsPortal id="responsive-portal">{children}</FixedElementsPortal>
  ) : (
    <>{children}</>
  );
}

ResponsiveFixedPortalWrapper.propTypes = {
  children: PropTypes.node,
};

export default ResponsiveFixedPortalWrapper;
